// 2025
// Author: Aaron Post

import { SceneObjectData } from "../scenedata/sceneobjectdata";

export const scenePlaceholder = (assetURL: string) => ({
    "sceneName": "GLB Scene",
    "version": "PlaceholderVersion",
    "content": [
      sceneObjectPlaceHolder(assetURL, "GLB")
    ]
});

export const sceneObjectPlaceHolder = (assetURL: string, name: string = "") : SceneObjectData => ({
  "src": assetURL,
  "name": name,
  "active": true,
  "transform": {},
  "behaviors": []
});